// @flow
import ApiService from '@api/service';
import type { QueryParams } from '@core/types';
import { API_PATHS } from '@app/constants/paths';

const { GROUP_CLASSES_EXPORT } = API_PATHS;

class GroupClassExportService {
  fetchExport = async (params: QueryParams): Promise<void> => {
    const response = await ApiService.request({
      method: 'get',
      url: GROUP_CLASSES_EXPORT,
      params,
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ExportCourscollectifs.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  };
}

export default new GroupClassExportService();
